import {Parameter, ToolboxImageImage} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum ImageFormat {
	PNG = "png",
	TIFF = "tiff",
	JPEG = "jpeg",
	GIF = "gif",
	BMP = "bmp",
	SVG = "svg"
}

export class PortalToolboxImageImage extends ToolboxImageImage implements Parameter {
	public format?: ImageFormat;

	constructor(data: any) {
		super(data);

		this.format = FunctionHelper.exists(data?.format) ? data.format : ImageFormat.JPEG;
	}

	public static getFormatDefault(): ImageFormat {
		return ImageFormat.JPEG;
	}

	public static fromJson(data: any): PortalToolboxImageImage {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxImageImage(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'format': this.format
		};
	}

	public clone(): PortalToolboxImageImage {
		return PortalToolboxImageImage.fromJson(this.toJson());
	}
}